// extracted by mini-css-extract-plugin
module.exports = {"c_card":"style_c_card__3aWor"};